module.exports = __webpack_public_path__ + "static/media/contacto.cac32140.jpg";